import { createContext } from "react";

export const EquipmentContext = createContext();
